import {
  POST_OPERATORS_CATALOG,
  POST_OPERATORS_CATALOG_SUCCESS,
  POST_OPERATORS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postOperatorsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case POST_OPERATORS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_OPERATORS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_OPERATORS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
